import script from "./ThreeDotMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeDotMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ThreeDotMenu.vue?vue&type=style&index=0&id=6b40b1b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b40b1b2"]])

export default __exports__